import React from 'react'
import { useLocation } from 'react-router-dom'

const TrackOrder = () => {

    const { state } = useLocation()

    const url = state.porter_tracking_url
    return (
        <div className="aspect-video w-full rounded-lg overflow-hidden shadow-lg">
            <iframe
                src="https://porter.in/track_live_order_v2?booking_id=CRN1494323630&customer_uuid=909fe7f2-3e08-4f09-8dc1-a540ffb4dafd&utm_medium=sender"
                className="w-full h-full border-none"
                allowFullScreen
            ></iframe>
        </div>

    )
}

export default TrackOrder